import React, { Fragment } from "react";

import { ProductPrice } from "@components/Product/Layout/ProductPrice/productPrice.component";

import { ECommerceProduct } from "../../eCommerce.types";

type Props = {
    currentPrice: number;
    currentConversionPrice: number | null;
    strikethroughPrice: number | null;
    product: ECommerceProduct;
    strikethroughConversionPrice: number | null;
    conversionUnit: string | null;
};

const Discount = ({
    currentPrice,
    currentConversionPrice,
    strikethroughPrice,
    product,
    strikethroughConversionPrice,
    conversionUnit,
}: Props) => {
    const getPrice = (conversionPrice: number | null, price: number) => {
        if (product.showConvertedPriceAsMainPrice) {
            return conversionPrice!;
        }

        return price;
    };

    return (
        <Fragment>
            {strikethroughPrice && (
                <div className="row d-flex justify-content-end">
                    <ProductPrice
                        price={getPrice(strikethroughConversionPrice, strikethroughPrice)}
                        variant="promo"
                        size="large"
                        conversionUnit={conversionUnit}
                        conversionPriceActive={
                            product.showConvertedPriceAsMainPrice
                        }
                    />
                </div>
            )}
            <div className="row d-flex justify-content-end">
                <ProductPrice
                    price={getPrice(
                        currentConversionPrice,
                        currentPrice,
                    )}
                    size="large"
                    conversionUnit={conversionUnit}
                    conversionPriceActive={
                        product.showConvertedPriceAsMainPrice
                    }
                />
            </div>
        </Fragment>
    );
};

export default Discount;
